module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Taro Gomi\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Taro Gomi is an internationally renowned author and illustrator who has created more than 400 books for readers of all ages, including the award-winning "), _c('I', [_vm._v("Over the Ocean")]), _vm._v(" and "), _c('I', [_vm._v("Bus Stops")]), _vm._v(", "), _c('I', [_vm._v("I Know Numbers!")]), _vm._v(", "), _c('I', [_vm._v("My Friends")]), _vm._v(", "), _c('I', [_vm._v("Spring Is Here!")]), _vm._v(", and "), _c('I', [_vm._v("I Really Want to See You, Grandma")]), _vm._v(". He lives in Tokyo, Japan.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/5Jj0Nl/images/9781452177427.jpg?1695331308800",
      "alt": "This image is the cover for the book Little Plane"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Little Plane\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Little Plane is learning to fly—and reaching for the sky—in this inspiring adventure for toddlers! ")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" When you’re small and on the go, there’s a lot to watch out for: tall trees, muddy hills, and more! With wings aloft, Little Plane keeps flying, weathering the bumps along the way with his initiative, confidence, and positive attitude. This colorful follow-up to "), _c('i', [_vm._v("Little Boat")]), _vm._v(" and "), _c('i', [_vm._v("Little Truck")]), _vm._v(" by beloved, award-winning author-illustrator Taro Gomi is a must for toddlers launching upward to big adventures!"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “I don’t just recommend this new book but ALL of his books—they’re kid-friendly wonderfulness.” —"), _c('i', [_vm._v("Imagination Soup")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Chronicle Books LLC\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0